// What cloud's own screens reach besides Me's context (useApi, the QueryClient).
import { createContext, useContext } from "react";
import type { CloudSession } from "./session";

export interface Cloud {
  session: CloudSession;
  /**
   * The query string the page was loaded with. OAuth's signed query is read
   * from here, raw: the router's parsing would change it.
   */
  bootSearch: string;
}

export const CloudContext = createContext<Cloud | null>(null);

export function useCloud(): Cloud {
  const cloud = useContext(CloudContext);
  if (!cloud) throw new Error("useCloud outside the cloud app");
  return cloud;
}
